import { ultraMarine } from '@cogneed/react-utils';
import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  gap: 4,
  '& > .MuiBox-root': {
    borderRadius: '50%',
    width: '50px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${ultraMarine[300]}`,
    '& > .MuiTypography-h4': {
      fontSize: 18,
    },
  },
  '& > .MuiTypography-body1': {
    textAlign: 'center',
    fontSize: 14,
  },
  '& > .MuiTypography-h6': {
    textAlign: 'center',
    fontSize: 18,
  },

});

export default StyledBox;
